import {useCallback, useState} from 'react';

import {validateDomains} from 'src/openapi/admin/apis/SsoApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ValidationResult} from '../../../utils/domain-validation';

export function useVerifyDomainApi() {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const verifyDomain = useCallback(async (domain: string): Promise<ValidationResult> => {
        setLoading(true);
        try {
            const response = await dispatch(
                validateDomains({domainValidationRequest: {domains: [domain]}}),
            );

            if (response.payload?.success) {
                const item = response.payload.data?.items?.[0];
                if (item?.errorMessage) {
                    return {valid: false, error: item.errorMessage};
                }
                return {valid: true, error: null, warning: item?.warningMessage ?? null};
            }

            return {valid: false, error: 'Failed to verify domain. Please try again.'};
        } catch {
            return {valid: false, error: 'Failed to verify domain. Please try again.'};
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    return {verifyDomain, loading};
}
